// Standard Library Imports
import React, { useEffect, useState } from 'react';
// Internal Module Imports
import TabsComponent from '../../../../../components/Tabs/Tabs';
import { useQueryParamWithDefault } from '../../../../../hooks';
// CSS Imports
import { NumberParam } from 'use-query-params';
import Ledger from './Ledger';
// import Overview from './Overview';

const Savings = ({ cId, admins = [], customers = [], selectedAdmin, setSelectedAdmin, selectedCustomer, setSelectedCustomer }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('nestedTab', NumberParam, 0, cId);
    const tabs = [
        {
            name: 'Ledger',
            component: (
                <Ledger
                    cId={cId}
                    admins={admins}
                    customers={customers}
                    selectedAdmin={selectedAdmin}
                    setSelectedAdmin={setSelectedAdmin}
                    selectedCustomer={selectedCustomer}
                    setSelectedCustomer={setSelectedCustomer}
                />
            ),
            tabId: 1,
        },
        // {
        //     name: 'Overview',
        //     component: (
        //         <Overview
        //             cId={cId}
        //             admins={admins}
        //             customers={customers}
        //             selectedAdmin={selectedAdmin}
        //             setSelectedAdmin={setSelectedAdmin}
        //             selectedCustomer={selectedCustomer}
        //             setSelectedCustomer={setSelectedCustomer}
        //         />
        //     ),
        //     tabId: 2,
        // },
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default Savings;
